import { BrowserCacheLocation } from '@azure/msal-browser';

export const environment = {
    production: false,
    edgeService: 'https://api.int.gms.ceres.siemens.cloud',
    // AppSync Events URLs
    appSyncRealtimeUrl: 'wss://appsync.api.int.gms.ceres.siemens.cloud/event/realtime',
    appSyncHttpUrl: 'https://appsync.api.int.gms.ceres.siemens.cloud/event',
    scdUrl: 'https://api.dev.scd.suites.siemens.cloud',
    languageAssetsPath: './assets/language/',
    siteCollection: '/test/10000120',
    tracking: false,
    whitelist: ['api.int.gms.ceres.siemens.cloud'],
    apiKey: 'CSNzjWXd4j71NClookSIc1WjWYB5BlPD15674OEr',
    tenant: 'INT - GMS',
    guestAccess: false,
    links: {
        documentOfferTemplate: 'https://scf.siemens.cloud/document/link/66454bfd-fc59-41e1-872d-58e0b85b6c8d',
        documentOfferTemplateEN: 'https://scf.siemens.cloud/document/link/deaa7a0e-2640-4bb9-a66c-04ccb519f3fd'
    },
    junoApp: 'https://juno.suites.siemens.cloud',
    junoApiURI: 'https://api.mail.wcs-apps.siemens.cloud/v2.0',
    junoAppId: '73a1c4a89ae54505824b6f0f4fcc78b3',
    commentRequiredThreshold: 10,
    timeSheetSumRowFloatingPoints: '1.2-2',
    timeSheetRounding: false,
    servicesDocumentationLink: '',
    msalConfig: {
        auth: {
            clientId: '280a4478-b277-499f-bc0a-a16a0c9b0a66', // Your application's client ID from Entra ID
            authority: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a', // Your tenant ID in format https://login.microsoftonline.com/${tenantId}
            redirectUri: window.location.origin, // Where to redirect after login, this needs to match exactly the redirectUri in Azure
            postLogoutRedirectUri: window.location.origin, // Where to redirect after logout
            navigateToLoginRequestUrl: true // Navigate back to the original request URL after login, this needs to match exactly the redirectUri in Azure
        },
        cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage, // Store auth data in session storage
            storeAuthStateInCookie: false // Don't use cookies for state
        },
        system: {
            allowPlatformBroker: false // Don't use platform brokers like WAM
        }
    },
    apiConfig: [
        {
            scopes: ['User.ReadBasic.All', 'User.Read'],
            uri: 'https://graph.microsoft.com/v1.0'
        },
        {
            scopes: ['https://api.int.gms.ceres.siemens.cloud/App.Access.All'],
            uri: 'https://api.int.gms.ceres.siemens.cloud/'
        }
    ]
};
